import { Construction } from 'lucide-react';
import { Card, CardBody, CardHeader } from '@/components/ui/Card';

export function PlaceholderPage({ title, description }: { title: string; description?: string }) {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">{title}</h1>
        {description ? <p className="text-sm text-neutral-500">{description}</p> : null}
      </div>
      <Card>
        <CardHeader title="Em construção" subtitle="Esta tela será implementada nas próximas fases." />
        <CardBody>
          <div className="flex items-center gap-4">
            <span className="grid h-12 w-12 place-items-center rounded bg-warning-bg text-warning">
              <Construction size={24} strokeWidth={1.75} />
            </span>
            <div className="text-sm text-neutral-600 dark:text-neutral-300">
              A API correspondente já está pronta no worker. O frontend será
              construído nas fases seguintes do roadmap.
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
